<template>
  <ion-content id="app">
    <InputTag showSearchWords="1"/>
    <Results/>
  </ion-content>
</template>

<script>
  import InputTag from "./../components/tag/InputTag.vue";
  import Results from "./../components/Results.vue";
  import {mapActions} from "vuex";
  import 'core-js/es6/array';

  export default {
    name: "Search",
    methods: {
      ...mapActions(["removeAllMessages"]),
    },
    components: {
      InputTag,
      Results
    },
    created() {
      this.removeAllMessages();
    }
  };

</script>


<style>

</style>
